/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, InlineNotification, Typography2 } from '@coursera/cds-core';
import { WarningIcon } from '@coursera/cds-icons';

const styles = {
  container: css`
    padding: 16px;
    display: flex;

    svg {
      margin-right: 16px;
      flex: 0 0 20px;
    }
  `,
  blue: css`
    background: #eaf4fe;
    border: none;
  `,
  grey: css`
    background: #f5f7f8;
    border: none;
  `,
  yellow: css`
    background: #fcebd0;
    border: none;
  `,
};

type Props = {
  text: string;
  theme: 'blue' | 'grey' | 'yellow';
  className?: string;
  filledIcon?: boolean;
  title?: string;
  'data-testid'?: string;
};

export const DrawerInfo: React.FC<Props> = ({ text, className, ...props }) => {
  return (
    <InlineNotification severity="information" data-testid={props['data-testid']} className={className}>
      <Typography2 component="p">{text}</Typography2>
    </InlineNotification>
  );
};

export const DrawerWarning: React.FC<Props> = ({ text, className, title, theme }) => {
  return (
    <div className={className} css={[styles.container, styles[theme || 'blue']]}>
      <WarningIcon size="large" color="default" />
      <Grid container direction="column">
        {title && (
          <Typography2 variant="subtitleMedium" component="span">
            {title}
          </Typography2>
        )}
        <Typography2 component="p">{text}</Typography2>
      </Grid>
    </div>
  );
};
